export function copiarConteudo(objeto) {
    // Converte o objeto para uma string JSON formatada
    const conteudoTexto = JSON.stringify(objeto, null, 2);

    // Cria um Blob a partir do conteúdo de texto
    const blob = new Blob([conteudoTexto], { type: 'text/plain' });

    // Cria um ClipboardItem com o Blob
    const clipboardItem = new ClipboardItem({ 'text/plain': blob });

    // Copia o ClipboardItem para a área de transferência
    navigator.clipboard.write([clipboardItem])
        .then(() => {
            console.log('Conteúdo copiado para a área de transferência como texto puro');
        })
        .catch(err => {
            console.error('Erro ao copiar para a área de transferência: ', err);
        });
}
